import React from 'react';
import { Github, Linkedin, ArrowUp } from 'lucide-react';

const socialLinks = [
  { name: 'GitHub', href: 'https://github.com/theandroguy', icon: Github },
  { name: 'LinkedIn', href: 'https://linkedin.com/in/tusharanand2000', icon: Linkedin },
];

const quickLinks = [
  { name: 'Home', href: '#home' },
  { name: 'Work', href: '#projects' },
  { name: 'Skills', href: '#skills' },
  { name: 'Contact', href: '#contact' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-ink text-cream border-t-[3px] border-cream">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="space-y-4">
            <h3 className="font-display text-2xl font-extrabold">Tushar Anand</h3>
            <p className="text-cream/70 leading-relaxed max-w-xs">
              Co-Founder &amp; CTO building a ride-hailing platform, plus web and mobile products
              with React, Node.js, and Java.
            </p>
            <div className="flex gap-3 pt-1">
              {socialLinks.map(({ name, href, icon: Icon }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={name}
                  className="flex h-11 w-11 items-center justify-center rounded-xl bg-cream text-ink brutal-border-thin brutal-hover"
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-bold text-sm uppercase tracking-wider text-sun mb-4">
              Quick Links
            </h4>
            <nav className="grid grid-cols-2 gap-3">
              {quickLinks.map((link) => (
                <a key={link.name} href={link.href} className="text-cream/80 hover:text-cream text-sm font-semibold transition-colors">
                  {link.name}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-display font-bold text-sm uppercase tracking-wider text-sun mb-4">
              Built With
            </h4>
            <div className="flex flex-wrap gap-2">
              {['React', 'Tailwind CSS', 'Framer Motion'].map((tech) => (
                <span key={tech} className="px-3 py-1 rounded-full bg-cream/10 text-cream text-xs font-bold brutal-border-thin border-cream/40">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t-2 border-cream/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-cream/60 text-sm">&copy; {currentYear} Tushar Anand. All rights reserved.</p>
          <div className="flex items-center gap-6 text-sm">
            <a href="#/privacy" className="text-cream/60 hover:text-cream transition-colors">Privacy Policy</a>
            <a href="#/terms" className="text-cream/60 hover:text-cream transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="absolute right-6 -top-6 flex h-12 w-12 items-center justify-center rounded-full bg-sun text-ink brutal-border brutal-hover"
        aria-label="Back to top"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </footer>
  );
};

export default Footer;
